import QuestionValueAlgebra from "../QuestionValueAlgebra";
import QuestionValue from "../QuestionValue";
import QuestionModule from "./QuestionModule";
import QuestionModel from "../QuestionModel";

export default class QuestionModuleAlgebra extends QuestionModule {
    constructor() {
        super();
        this._equations = [];
        this._coefficentRange = {min: 1, max: 1};
    }

    create(data) {
        const question = super.create(data);
        question.hasQuestionMark = false;
        if (data.coefficient_range) this._coefficentRange = data.coefficient_range;
        this.generateOptions(question, data.values, data);
        return question;
    }

    generateOptions(question, total, data) {
        switch (question.type) {
            case QuestionModel.TYPE_MIXED:
            case QuestionModel.TYPE_DIVISION:
            case QuestionModel.TYPE_MULTIPLICATION:
            case QuestionModel.TYPE_SUBTRACTION:
            case QuestionModel.TYPE_ADDITION: {
                this.generateSingleEquation(question, total, data);
                break;
            }
            case QuestionModel.TYPE_DOUBLE_UNKNOWN: {
                this.generateDoubleEquation(question, total, data);
                break;
            }
            case QuestionModel.TYPE_FIND_REST: {
                this.generateFindRest(question, total, data);
                break;
            }
        }
    }

    generateSingleEquation(question, total, data) {
        //TODO - rushed for time, this should be tidied up
        if (data.type !== QuestionModel.TYPE_DIVISION) {

            const coefficient = P3.math.randomInt(this._coefficentRange.min, this._coefficentRange.max);

            const characterVariables = P3.utils.shuffleArray(data.variable_character);

            if (characterVariables[0] === "?" || characterVariables[1] === "?") {
                question.hasQuestionMark = true;
            }

            const myVar = P3.math.randomInt(data.variable_range.min, data.variable_range.max);
            question.options.push(new QuestionValue(myVar));//add answer to options

            //add some unique constants to options
            let k = 100;
            let arr = [myVar];
            while (k-- > 0 && question.options.length < 5) {
                const rand = P3.math.randomInt(data.variable_range.min, data.variable_range.max);
                if (arr.indexOf(rand) === -1) {
                    arr.push(rand);
                    question.options.push(new QuestionValue(rand));
                }
            }

            //const myVar = question.options[P3.math.randomInt(0, question.options.length - 1)].value;


            P3.utils.shuffleArray(question.options);//and shuffle

            //add some constants to equation
            for (let i = 0; i < total; i++) {
                question.values.push(new QuestionValue(P3.math.randomInt(question.range.min, question.range.max)));
            }

            //if negating sort values, cheap fix for
            if (data.type === QuestionModel.TYPE_MIXED) {
                question.values.sort((a, b) => {
                    return b.value - a.value;
                });
            }

            //add algebra value to position
            const algValue = new QuestionValueAlgebra(coefficient, myVar, characterVariables ? characterVariables[0] : "𝒳");
            question.values.push(algValue);
            question.part = question.values.indexOf(algValue);

            let result = question.values[0].value;//start at first value ( no operation occurred yet)
            for (let i = 1; i < question.values.length; i++) {
                //go through again and work out result
                switch (question.type) {
                    case QuestionModel.TYPE_ADDITION : {
                        result += question.values[i].value;
                        if (i > 0) {
                            question.operands.push("+");
                        }
                        break;
                    }
                    case QuestionModel.TYPE_SUBTRACTION : {
                        result -= question.values[i].value;
                        if (i > 0) {
                            question.operands.push("-");
                        }
                        break;
                    }
                    case QuestionModel.TYPE_MULTIPLICATION : {
                        result *= question.values[i].value;
                        if (i > 0) {
                            question.operands.push("×");
                        }
                        break;
                    }
                    case QuestionModel.TYPE_DIVISION : {
                        result /= question.values[i].value;
                        if (i > 0) {
                            question.operands.push("÷");
                        }
                        break;
                    }
                    case QuestionModel.TYPE_MIXED : {
                        const rand = Math.random();
                        if (rand < 0.5 || (question.operands.length > 0 && question.operands[question.operands.length - 1] === "-")) {
                            result += question.values[i].value;
                            if (i > 0) {
                                question.operands.push("+");
                            }
                        }
                        else {
                            result -= question.values[i].value;
                            if (i > 0) {
                                question.operands.push("-");
                            }
                        }
                        break;
                    }
                }
            }

            question.operands.push("=");
            question.values.push(new QuestionValue(result));
        }
        else {
            this.generateDivision(question, total, data);
        }
    }

    generateDivision(question, total, data) {

        const characterVariables = P3.utils.shuffleArray(data.variable_character);

        if (characterVariables[0] === "?" || characterVariables[1] === "?") {
            question.hasQuestionMark = true;
        }

        //for division work out result first
        const result = P3.math.randomInt(data.range.min, data.range.max);

        //next work out the numerator using our unknown
        const coefficient = 1;//not needed now but could be picked from range
        const unknownValue = P3.math.randomInt(data.variable_range.min, data.variable_range.max) * coefficient;

        const numerator = unknownValue * result;

        //add first value in equation (numerator)
        question.values.push(new QuestionValue(numerator));

        //add algebra value
        const algebraValue = new QuestionValueAlgebra(coefficient, unknownValue, characterVariables ? characterVariables[0] : "𝒳");
        question.values.push(algebraValue);
        question.part = question.values.indexOf(algebraValue);

        //add result
        question.values.push(new QuestionValue(result));

        question.options.push(new QuestionValue(unknownValue));

        let k = 100;
        let arr = [unknownValue];
        while (k-- > 0 && question.options.length < 5) {
            const rand = P3.math.randomInt(unknownValue - 8, unknownValue + 10);
            if (arr.indexOf(rand) === -1) {
                arr.push(rand);
                question.options.push(new QuestionValue(rand));
            }
        }
        P3.utils.shuffleArray(question.options);

        for (let i = 1; i < question.values.length - 1; i++) {
            question.operands.push("÷");
        }

        question.operands.push("=");
    }

    generateDoubleEquation(question, total, data) {
        //TODO - complete
        const types = [QuestionModel.TYPE_ADDITION, QuestionModel.TYPE_SUBTRACTION, QuestionModel.TYPE_MULTIPLICATION];

        let coefficient = P3.math.randomInt(this._coefficentRange.min, this._coefficentRange.max);
        const characterVariables = P3.utils.shuffleArray(data.variable_character);

        if (characterVariables[0] === "?" || characterVariables[1] === "?") {
            question.hasQuestionMark = true;
        }

        //add some unique constants to options
        let k = 100;
        let arr = [];
        while (k-- > 0 && question.options.length < 5) {
            const rand = P3.math.randomInt(data.variable_range.min, data.variable_range.max);
            if (arr.indexOf(rand) === -1) {
                arr.push(rand);
                question.options.push(new QuestionValue(rand));
            }
        }

        const ndxVar = P3.math.randomInt(0, question.options.length - 1);

        let myVar = question.options[ndxVar].value;

        question.options.splice(ndxVar, 1);

        //add some constants to equation
        for (let i = 0; i < 1; i++) {
            question.values.push(new QuestionValue(P3.math.randomInt(question.range.min, question.range.max)));
        }

        //add algebra value to random position
        let algValue = new QuestionValueAlgebra(coefficient, myVar, characterVariables ? characterVariables[0] : "𝒳");
        question.values.push(algValue);
        question.part = question.values.indexOf(algValue);

        const type = P3.utils.selectRandom(types);

        let result = question.values[0].value;//start at first value ( no operation occurred yet)
        for (let i = 1; i < question.values.length; i++) {
            //go through again and work out result
            switch (type) {
                case QuestionModel.TYPE_ADDITION : {
                    result += question.values[i].value;
                    if (i > 0) {
                        question.operands.push("+");
                    }
                    break;
                }
                case QuestionModel.TYPE_SUBTRACTION : {
                    result -= question.values[i].value;
                    if (i > 0) {
                        question.operands.push("-");
                    }
                    break;
                }
                case QuestionModel.TYPE_MULTIPLICATION : {
                    result *= question.values[i].value;
                    if (i > 0) {
                        question.operands.push("×");
                    }
                    break;
                }
                case QuestionModel.TYPE_DIVISION : {
                    result /= question.values[i].value;
                    if (i > 0) {
                        question.operands.push("÷");
                    }
                    break;
                }
                case QuestionModel.TYPE_MIXED : {
                    const rand = Math.random();
                    if (rand < 0.5 || (question.operands.length > 0 && question.operands[question.operands.length - 1] === "-")) {
                        result += question.values[i].value;
                        if (i > 0) {
                            question.operands.push("+");
                        }
                    }
                    else {
                        result -= question.values[i].value;
                        if (i > 0) {
                            question.operands.push("-");
                        }
                    }
                    break;
                }
            }
        }

        question.operands.push("=");
        question.values.push(new QuestionValue(result));

        //now lets just do the same again to build our second formula
        coefficient = P3.math.randomInt(this._coefficentRange.min, this._coefficentRange.max);
        algValue = new QuestionValueAlgebra(coefficient, myVar, characterVariables ? characterVariables[0] : "𝒳");
        question.values.push(algValue);

        myVar = question.options[P3.math.randomInt(0, question.options.length - 1)].value;
        //add algebra value to random position
        coefficient = P3.math.randomInt(this._coefficentRange.min, this._coefficentRange.max);
        algValue = new QuestionValueAlgebra(coefficient, myVar, characterVariables ? characterVariables[1] : "𝒴");
        question.values.push(algValue);
        question.part = question.values.indexOf(algValue);

        const valuesEnd = question.values.length - 2;

        result = question.values[valuesEnd].value;//start at first value ( no operation occurred yet)
        for (let i = valuesEnd + 1; i < question.values.length; i++) {
            //go through again and work out result
            switch (QuestionModel.TYPE_ADDITION) {
                case QuestionModel.TYPE_ADDITION : {
                    result += question.values[i].value;
                    if (i > 0) {
                        question.operands.push("+");
                    }
                    break;
                }
                case QuestionModel.TYPE_SUBTRACTION : {
                    result -= question.values[i].value;
                    if (i > 0) {
                        question.operands.push("-");
                    }
                    break;
                }
                case QuestionModel.TYPE_MULTIPLICATION : {
                    result *= question.values[i].value;
                    if (i > 0) {
                        question.operands.push("×");
                    }
                    break;
                }
                case QuestionModel.TYPE_DIVISION : {
                    result /= question.values[i].value;
                    if (i > 0) {
                        question.operands.push("÷");
                    }
                    break;
                }
                case QuestionModel.TYPE_MIXED : {
                    const rand = Math.random();
                    if (rand < 0.5 || (question.operands.length > 0 && question.operands[question.operands.length - 1] === "-")) {
                        result += question.values[i].value;
                        if (i > 0) {
                            question.operands.push("+");
                        }
                    }
                    else {
                        result -= question.values[i].value;
                        if (i > 0) {
                            question.operands.push("-");
                        }
                    }
                    break;
                }
            }
        }

        question.operands.push("=");
        question.values.push(new QuestionValue(result));
    }

    generateFindRest(question, totalOptions, data) {
        //There are five dragon eggs in a nest. Three are green and rest are golden. How many golden eggs are there?
        const totalA = P3.math.randomInt(question.range.min, question.range.max);
        const totalB = P3.math.randomInt(question.range.min, question.range.max);
        const sum = totalA + totalB;

        question.values.push(new QuestionValue(sum));
        question.values.push(new QuestionValue(totalA));
        question.values.push(new QuestionValue(totalB));

        question.part = 2;

        question.options.push(new QuestionValue(totalB));

        let k = 100;
        let arr = [totalB];
        while (k-- > 0 && question.options.length < totalOptions) {
            const rand = P3.math.randomInt(question.range.min, question.range.max);
            if (arr.indexOf(rand) === -1) {
                arr.push(rand);
                question.options.push(new QuestionValue(rand));
            }
        }

        P3.utils.shuffleArray(question.options);
    }
}